module.exports = __webpack_public_path__ + "static/media/loader.fb98870b.svg";